import React, { useState } from "react";
import "./FeedbackPopup.css";

const tagOptions = {
  1: [
    "Конфликтный",
    "Жалуется",
    "Грубый",
    "Недовольный",
    "Скандальный",
    "Неблагодарный",
  ],
  2: [
    "Придирчивый",
    "Медленный",
    "Требовательный",
    "Шумный",
    "Нетерпеливый",
    "Скептичный",
  ],
  3: [
    "Нейтральный",
    "Обычный",
    "Спокойный",
    "Неприметный",
    "Сдержанный",
    "Ожидающий",
  ],
  4: [
    "Вежливый",
    "Дружелюбный",
    "Щедрый",
    "Постоянный",
    "Благодарный",
    "Спокойный",
  ],
  5: [
    "Лояльный",
    "Щедрый",
    "Харизматичный",
    "Рекомендует",
    "Оставляет хорошие чаевые",
    "Приятный в общении",
  ],
};

const starDescriptions = [
  "Очень плохой гость",
  "Неприятный гость",
  "Средний гость",
  "Хороший гость",
  "Идеальный гость",
];

const FeedbackPopup = ({ guest, onClose }) => {
  const [rating, setRating] = useState(0);
  const [selectedTags, setSelectedTags] = useState([]);
  const [comment, setComment] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handleRating = (stars) => {
    setRating(stars);
    setSelectedTags([]);
    setMessage("");
  };

  const toggleTag = (tag) => {
    setSelectedTags((prev) =>
      prev.includes(tag) ? prev.filter((t) => t !== tag) : [...prev, tag]
    );
  };

  const submitFeedback = async () => {
    if (rating === 0) {
      setMessage("⚠ Пожалуйста, выберите рейтинг!");
      return;
    }

    setLoading(true);
    setMessage("");

    const requestBody = {
      user_id: guest.id,
      place_id: "shka17c8h3",
      star_rating: rating,
      tag_words: selectedTags.length > 0 ? selectedTags.join(", ") : "",
      comments: comment.trim() !== "" ? comment : "",
    };

    try {
      const response = await fetch(
        "https://uvjwfdf5aa.execute-api.eu-west-1.amazonaws.com/test/guest-ranking-system",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(requestBody),
        }
      );
      const data = await response.json();
      if (data.statusCode === 200) {
        setMessage("✅ Отзыв успешно отправлен!");
        setTimeout(onClose, 1500);
      } else {
        setMessage("❌ Ошибка! Заполните все данные.");
      }
    } catch (error) {
      setMessage("❌ Ошибка сети!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="popup-overlay">
      <div className="popup">
        <button className="popup-close" onClick={onClose}>
          ✖
        </button>
        <h3>Оценить гостя</h3>

        <div className="star-rating">
          {[1, 2, 3, 4, 5].map((star) => (
            <svg
              key={star}
              className={`star ${star <= rating ? "selected" : ""}`}
              onClick={() => handleRating(star)}
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="30"
              height="30"
              fill={star <= rating ? "gold" : "lightgray"}
            >
              <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
            </svg>
          ))}
        </div>

        <p className="star-description">
          {rating > 0 ? starDescriptions[rating - 1] : "Выберите рейтинг"}
        </p>

        <div className="tag-selection">
          {rating > 0 &&
            tagOptions[rating].map((tag) => (
              <button
                key={tag}
                className={`tag-button ${
                  selectedTags.includes(tag) ? "selected" : ""
                }`}
                onClick={() => toggleTag(tag)}
              >
                {tag}
              </button>
            ))}
        </div>

        <textarea
          className="comment-box"
          placeholder="Комментарий..."
          value={comment}
          onChange={(e) => setComment(e.target.value)}
        ></textarea>

        <button
          className="submit-btn"
          onClick={submitFeedback}
          disabled={loading}
        >
          {loading ? "Отправка..." : "Сохранить"}
        </button>
        {message && <p className="message">{message}</p>}
      </div>
    </div>
  );
};

export default FeedbackPopup;
